// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file kitecorp/transferify/transfer/v1/transfer_changes.proto (package kitecorp.transferify.transfer.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { EmptySchema } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty } from "@bufbuild/protobuf/wkt";
import { file_kitecorp_options_v1_options } from "../../../options/v1/options_pb";
import type { ExpireAfter, TransferState } from "./transfer_pb";
import { file_kitecorp_transferify_transfer_v1_transfer } from "./transfer_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file kitecorp/transferify/transfer/v1/transfer_changes.proto.
 */
export const file_kitecorp_transferify_transfer_v1_transfer_changes: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_empty, file_kitecorp_options_v1_options, file_kitecorp_transferify_transfer_v1_transfer]);

/**
 * Asks to change a sent transfer. Every field but transfer_id is a change only when it is present.
 *
 * @generated from message kitecorp.transferify.transfer.v1.UpdateTransferRequest
 */
export type UpdateTransferRequest = Message<"kitecorp.transferify.transfer.v1.UpdateTransferRequest"> & {
  /**
   * The transfer's id, a UUID. The caller must own it.
   *
   * @generated from field: string transfer_id = 1;
   */
  transferId: string;

  /**
   * The new total retention, measured from the transfer's creation. It must not be shorter than the current one, and
   * the same one changes nothing. It must be inside the plan's window. Absent: the retention is unchanged.
   *
   * @generated from field: optional kitecorp.transferify.transfer.v1.ExpireAfter expire_after = 2;
   */
  expireAfter?: ExpireAfter | undefined;

  /**
   * The new sender note. A present blank note clears the note. Absent: the note is unchanged.
   *
   * @generated from field: optional string message = 3;
   */
  message?: string | undefined;

  /**
   * Email addresses to add as recipients. Each new address is emailed the download link, and an address already
   * reserved is skipped. The recipient count after the change must stay within the plan's limit. Empty: none added.
   *
   * @generated from field: repeated string add_recipients = 4;
   */
  addRecipients: string[];

  /**
   * Email addresses to take off the recipients. An email already delivered cannot be unsent, but a revoked address
   * stops being listed and is left out of later redelivery. An unknown address is ignored. Empty: none taken off.
   *
   * @generated from field: repeated string revoke_recipients = 5;
   */
  revokeRecipients: string[];
};

/**
 * Describes the message kitecorp.transferify.transfer.v1.UpdateTransferRequest.
 * Use `create(UpdateTransferRequestSchema)` to create a new message.
 */
export const UpdateTransferRequestSchema: GenMessage<UpdateTransferRequest> = /*@__PURE__*/
  messageDesc(file_kitecorp_transferify_transfer_v1_transfer_changes, 0);

/**
 * The transfer after the change, without its files.
 *
 * @generated from message kitecorp.transferify.transfer.v1.UpdateTransferResponse
 */
export type UpdateTransferResponse = Message<"kitecorp.transferify.transfer.v1.UpdateTransferResponse"> & {
  /**
   * The changed transfer.
   *
   * @generated from field: kitecorp.transferify.transfer.v1.TransferState transfer = 1;
   */
  transfer?: TransferState | undefined;
};

/**
 * Describes the message kitecorp.transferify.transfer.v1.UpdateTransferResponse.
 * Use `create(UpdateTransferResponseSchema)` to create a new message.
 */
export const UpdateTransferResponseSchema: GenMessage<UpdateTransferResponse> = /*@__PURE__*/
  messageDesc(file_kitecorp_transferify_transfer_v1_transfer_changes, 1);

/**
 * Asks to recover an expired transfer.
 *
 * @generated from message kitecorp.transferify.transfer.v1.RecoverTransferRequest
 */
export type RecoverTransferRequest = Message<"kitecorp.transferify.transfer.v1.RecoverTransferRequest"> & {
  /**
   * The transfer's id, a UUID. The caller must own it.
   *
   * @generated from field: string transfer_id = 1;
   */
  transferId: string;
};

/**
 * Describes the message kitecorp.transferify.transfer.v1.RecoverTransferRequest.
 * Use `create(RecoverTransferRequestSchema)` to create a new message.
 */
export const RecoverTransferRequestSchema: GenMessage<RecoverTransferRequest> = /*@__PURE__*/
  messageDesc(file_kitecorp_transferify_transfer_v1_transfer_changes, 2);

/**
 * The transfer after its recovery, without its files.
 *
 * @generated from message kitecorp.transferify.transfer.v1.RecoverTransferResponse
 */
export type RecoverTransferResponse = Message<"kitecorp.transferify.transfer.v1.RecoverTransferResponse"> & {
  /**
   * The recovered transfer.
   *
   * @generated from field: kitecorp.transferify.transfer.v1.TransferState transfer = 1;
   */
  transfer?: TransferState | undefined;
};

/**
 * Describes the message kitecorp.transferify.transfer.v1.RecoverTransferResponse.
 * Use `create(RecoverTransferResponseSchema)` to create a new message.
 */
export const RecoverTransferResponseSchema: GenMessage<RecoverTransferResponse> = /*@__PURE__*/
  messageDesc(file_kitecorp_transferify_transfer_v1_transfer_changes, 3);

/**
 * Asks to place a transfer under legal hold.
 *
 * @generated from message kitecorp.transferify.transfer.v1.PlaceLegalHoldRequest
 */
export type PlaceLegalHoldRequest = Message<"kitecorp.transferify.transfer.v1.PlaceLegalHoldRequest"> & {
  /**
   * The transfer's id, a UUID. The caller must own it.
   *
   * @generated from field: string transfer_id = 1;
   */
  transferId: string;
};

/**
 * Describes the message kitecorp.transferify.transfer.v1.PlaceLegalHoldRequest.
 * Use `create(PlaceLegalHoldRequestSchema)` to create a new message.
 */
export const PlaceLegalHoldRequestSchema: GenMessage<PlaceLegalHoldRequest> = /*@__PURE__*/
  messageDesc(file_kitecorp_transferify_transfer_v1_transfer_changes, 4);

/**
 * The transfer after the hold, without its files.
 *
 * @generated from message kitecorp.transferify.transfer.v1.PlaceLegalHoldResponse
 */
export type PlaceLegalHoldResponse = Message<"kitecorp.transferify.transfer.v1.PlaceLegalHoldResponse"> & {
  /**
   * The held transfer.
   *
   * @generated from field: kitecorp.transferify.transfer.v1.TransferState transfer = 1;
   */
  transfer?: TransferState | undefined;
};

/**
 * Describes the message kitecorp.transferify.transfer.v1.PlaceLegalHoldResponse.
 * Use `create(PlaceLegalHoldResponseSchema)` to create a new message.
 */
export const PlaceLegalHoldResponseSchema: GenMessage<PlaceLegalHoldResponse> = /*@__PURE__*/
  messageDesc(file_kitecorp_transferify_transfer_v1_transfer_changes, 5);

/**
 * Asks to lift a transfer's legal hold.
 *
 * @generated from message kitecorp.transferify.transfer.v1.ReleaseLegalHoldRequest
 */
export type ReleaseLegalHoldRequest = Message<"kitecorp.transferify.transfer.v1.ReleaseLegalHoldRequest"> & {
  /**
   * The transfer's id, a UUID. The caller must own it, or be the account a file request bills the transfer to.
   *
   * @generated from field: string transfer_id = 1;
   */
  transferId: string;
};

/**
 * Describes the message kitecorp.transferify.transfer.v1.ReleaseLegalHoldRequest.
 * Use `create(ReleaseLegalHoldRequestSchema)` to create a new message.
 */
export const ReleaseLegalHoldRequestSchema: GenMessage<ReleaseLegalHoldRequest> = /*@__PURE__*/
  messageDesc(file_kitecorp_transferify_transfer_v1_transfer_changes, 6);

/**
 * The transfer after the release, without its files.
 *
 * @generated from message kitecorp.transferify.transfer.v1.ReleaseLegalHoldResponse
 */
export type ReleaseLegalHoldResponse = Message<"kitecorp.transferify.transfer.v1.ReleaseLegalHoldResponse"> & {
  /**
   * The released transfer.
   *
   * @generated from field: kitecorp.transferify.transfer.v1.TransferState transfer = 1;
   */
  transfer?: TransferState | undefined;
};

/**
 * Describes the message kitecorp.transferify.transfer.v1.ReleaseLegalHoldResponse.
 * Use `create(ReleaseLegalHoldResponseSchema)` to create a new message.
 */
export const ReleaseLegalHoldResponseSchema: GenMessage<ReleaseLegalHoldResponse> = /*@__PURE__*/
  messageDesc(file_kitecorp_transferify_transfer_v1_transfer_changes, 7);

/**
 * Asks to delete a transfer with all its files.
 *
 * @generated from message kitecorp.transferify.transfer.v1.DeleteTransferRequest
 */
export type DeleteTransferRequest = Message<"kitecorp.transferify.transfer.v1.DeleteTransferRequest"> & {
  /**
   * The transfer's id, a UUID. The caller must own it, or be the account a file request bills the transfer to.
   *
   * @generated from field: string transfer_id = 1;
   */
  transferId: string;
};

/**
 * Describes the message kitecorp.transferify.transfer.v1.DeleteTransferRequest.
 * Use `create(DeleteTransferRequestSchema)` to create a new message.
 */
export const DeleteTransferRequestSchema: GenMessage<DeleteTransferRequest> = /*@__PURE__*/
  messageDesc(file_kitecorp_transferify_transfer_v1_transfer_changes, 8);

/**
 * Asks to delete one file of a transfer.
 *
 * @generated from message kitecorp.transferify.transfer.v1.DeleteTransferFileRequest
 */
export type DeleteTransferFileRequest = Message<"kitecorp.transferify.transfer.v1.DeleteTransferFileRequest"> & {
  /**
   * The file's id, a UUID. The caller must own the transfer that holds it.
   *
   * @generated from field: string file_id = 1;
   */
  fileId: string;
};

/**
 * Describes the message kitecorp.transferify.transfer.v1.DeleteTransferFileRequest.
 * Use `create(DeleteTransferFileRequestSchema)` to create a new message.
 */
export const DeleteTransferFileRequestSchema: GenMessage<DeleteTransferFileRequest> = /*@__PURE__*/
  messageDesc(file_kitecorp_transferify_transfer_v1_transfer_changes, 9);

/**
 * What the owner of a sent transfer can change or delete (kitecorp/contracts#92). Each call names the transfer or the
 * file it acts on; the account is never named in a message. A transfer that does not exist and a transfer the caller
 * may not act on are refused alike, as NOT_FOUND with reason TRANSFER_UNKNOWN. The caller may act on a transfer it
 * owns and, to release a hold or to delete, on one that a file request of its own bills it for. DeleteTransferFile
 * tells two cases apart: a file id that does not exist is NOT_FOUND with reason UPLOAD_FILE_NOT_PART_OF_TRANSFER, and
 * a file of a transfer the caller may not act on is NOT_FOUND with reason TRANSFER_UNKNOWN.
 *
 * @generated from service kitecorp.transferify.transfer.v1.TransferChangeService
 */
export const TransferChangeService: GenService<{
  /**
   * Changes a sent transfer: its retention, its note and its recipients. Each field is a change only when it is
   * present. A call that carries no change is refused as INVALID_ARGUMENT with reason REQUEST_INVALID before the
   * transfer is read. A plan that does not allow a present change is refused as INVALID_ARGUMENT with reason
   * TRANSFER_EXTEND_EXPIRY_NOT_ALLOWED for the retention or TRANSFER_EDIT_NOT_ALLOWED for the note and the
   * recipients. The answer is the transfer as it stands after the change, without its files. Recipients added by the
   * call are emailed the download link after the change is saved.
   *
   * @generated from rpc kitecorp.transferify.transfer.v1.TransferChangeService.UpdateTransfer
   */
  updateTransfer: {
    methodKind: "unary";
    input: typeof UpdateTransferRequestSchema;
    output: typeof UpdateTransferResponseSchema;
  },
  /**
   * Re-opens an expired transfer's link until the kept files are deleted. A transfer has one recovery. A plan that does
   * not sell it is refused as INVALID_ARGUMENT with reason TRANSFER_RECOVER_NOT_ALLOWED, and a transfer whose sender
   * did not switch recovery on with reason TRANSFER_RECOVERY_NOT_ENABLED. A transfer that was never kept for recovery
   * is refused with reason TRANSFER_RECOVERY_UNSUPPORTED, one that has not expired with TRANSFER_NOT_EXPIRED, one whose
   * recovery is spent with TRANSFER_ALREADY_RECOVERED and one whose window closed with
   * TRANSFER_RECOVERY_WINDOW_ELAPSED, all as INVALID_ARGUMENT.
   *
   * @generated from rpc kitecorp.transferify.transfer.v1.TransferChangeService.RecoverTransfer
   */
  recoverTransfer: {
    methodKind: "unary";
    input: typeof RecoverTransferRequestSchema;
    output: typeof RecoverTransferResponseSchema;
  },
  /**
   * Places a transfer under legal hold: its link stops expiring and the transfer cannot be deleted until the hold is
   * released. Placing a hold on a transfer that is already held changes nothing. A plan that does not allow holds, and
   * a transfer bought as a paid over-limit allowance, are refused as INVALID_ARGUMENT with reason
   * TRANSFER_LEGAL_HOLD_NOT_ALLOWED. A transfer that can never be held is refused with reason
   * TRANSFER_LEGAL_HOLD_UNSUPPORTED, one whose upload has not finished with TRANSFER_NOT_COMPLETE and one whose link
   * expired with TRANSFER_EXPIRED, all as INVALID_ARGUMENT.
   *
   * @generated from rpc kitecorp.transferify.transfer.v1.TransferChangeService.PlaceLegalHold
   */
  placeLegalHold: {
    methodKind: "unary";
    input: typeof PlaceLegalHoldRequestSchema;
    output: typeof PlaceLegalHoldResponseSchema;
  },
  /**
   * Lifts a legal hold, so the transfer expires as it always would have. Releasing a transfer that is not held changes
   * nothing. Any plan may release.
   *
   * @generated from rpc kitecorp.transferify.transfer.v1.TransferChangeService.ReleaseLegalHold
   */
  releaseLegalHold: {
    methodKind: "unary";
    input: typeof ReleaseLegalHoldRequestSchema;
    output: typeof ReleaseLegalHoldResponseSchema;
  },
  /**
   * Deletes a transfer with all its files, so every link to it stops working at once. A transfer under legal hold is
   * refused as ALREADY_EXISTS with reason TRANSFER_UNDER_LEGAL_HOLD.
   *
   * @generated from rpc kitecorp.transferify.transfer.v1.TransferChangeService.DeleteTransfer
   */
  deleteTransfer: {
    methodKind: "unary";
    input: typeof DeleteTransferRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Deletes one file of a transfer. Deleting the last file deletes the transfer. A file that does not exist is refused
   * as NOT_FOUND with reason UPLOAD_FILE_NOT_PART_OF_TRANSFER, and a file of a transfer another account owns with
   * reason TRANSFER_UNKNOWN. A file of a transfer under legal hold is refused as ALREADY_EXISTS with reason
   * TRANSFER_UNDER_LEGAL_HOLD.
   *
   * @generated from rpc kitecorp.transferify.transfer.v1.TransferChangeService.DeleteTransferFile
   */
  deleteTransferFile: {
    methodKind: "unary";
    input: typeof DeleteTransferFileRequestSchema;
    output: typeof EmptySchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_kitecorp_transferify_transfer_v1_transfer_changes, 0);

